import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export const store = new Vuex.Store({
    state:{
        loadAnimAc:false,
        postServer:"http://ws.monoryum.com/"
    }
});




// WEBPACK FOOTER //
// ./store/store.js